import PlayerReducer from './reducer';
import * as playerActions from './actions';

export {playerActions};
export default PlayerReducer;